import Role from './role';
import { type } from '../core/serialization';
export default class User {
  id: number = null;
  isAdmin: boolean = false;
  isLabRat: boolean = false;
  firstName: string = null;
  lastName: string = null;
  email: string = null;
  personUuid: string = null;
  uciUuid: string = null;
  activeTeamCount: number = null;
  managedDivisionCount: number = null;
  managedTeamIds: number[] = [];
  @type(Role) roles: Role[] = [];
}
